import Environment from "../../utils/environment";
import Cookies from 'js-cookie';

/** 
 * SCクリック（ANAさん側で集計するAdobe Analyticsでの記録）の処理。
 * （主に広告バナーや連携ボタンのクリック時の計測のために利用する。）
 * @param name クリック名。（集計時に識別するための名称。ANAさんから指定してもらう値。）
 * */
export default function scClick(name: string) {
  /** 環境変数で指定された環境種別を識別するための値。 */
  const stageEnv = process.env['REACT_APP_STAGE_ENV'];
  // 環境変数「REACT_APP_STAGE_ENV」が設定されている、かつ、
  // その値に本番環境のものが設定されている場合のみSCクリックを実行する。
  if (stageEnv && Environment.isProduction(stageEnv)) {
    try {
      window.SCClick(name);
    }
    catch(e) {
      console.error(e);
    }
  }
  else {
    console.log(`SCClick: ${name}`);
    const cookieKey = 'ana_airport_access_debug_scclick';
    // デバッグ用のCookieを入れ込めます
    Cookies.set(cookieKey, name);
  }
  return null;
}
